import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {BaseDialogComponent, RefModelNode, customNodeIdRegex} from '@q9elements/ui-kit/common';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {RmeNodeDaoAbstractService} from '../../../core/abstract/rme-node-dao-abstract.service';

@Component({
  selector: 'app-edit-model-dialog',
  templateUrl: './edit-model-dialog.component.html',
  styleUrls: ['./edit-model-dialog.component.scss']
})
export class EditModelDialogComponent extends BaseDialogComponent implements OnInit {
  public editNodeForm: FormGroup;
  public nameRequired: boolean;
  public customIdRequired: boolean;

  private baseNameValidators = [Q9Validators.minLength(2), Q9Validators.maxLength(250)];
  private baseCustomIdValidators = [
    Q9Validators.maxLength(60),
    Q9Validators.pattern(customNodeIdRegex)
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: RefModelNode,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EditModelDialogComponent>,
    private rmeNodeDaoAbstractService: RmeNodeDaoAbstractService
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.customIdRequired = !!this.data?.customId;
    this.nameRequired = !!this.data?.name;

    this.editNodeForm = new FormGroup({
      name: new FormControl(this.data?.name, [
        ...(this.nameRequired ? [Q9Validators.required()] : []),
        ...this.baseNameValidators
      ]),
      customId: new FormControl(this.data?.customId || '', [
        ...(this.customIdRequired ? [Q9Validators.required()] : []),
        ...this.baseCustomIdValidators
      ]),
      description: new FormControl(this.data?.description, [Q9Validators.maxLength(5000)])
    });

    this.editNodeForm.valueChanges.subscribe(() => this.resetValidation());
  }
  private resetValidation(): void {
    const nameControl = this.editNodeForm.get('name');
    const customIdControl = this.editNodeForm.get('customId');
    const name = nameControl.value ? nameControl.value.trim() : null;
    const customId = customIdControl.value ? customIdControl.value.trim() : '';

    this.nameRequired = !customId;
    const nameValidators = !customId
      ? [Q9Validators.required(), ...this.baseNameValidators]
      : this.baseCustomIdValidators;
    nameControl.setValidators(nameValidators);

    this.customIdRequired = !name;
    const customIdValidators = !name
      ? [Q9Validators.required(), ...this.baseCustomIdValidators]
      : this.baseCustomIdValidators;
    customIdControl.setValidators(customIdValidators);

    this.cdr.detectChanges();
  }

  override onSubmit() {
    if (this.editNodeForm.invalid || this.isSubmitted) {
      this.editNodeForm.markAllAsTouched();

      return;
    }

    return super.onSubmit();
  }

  override sendSubmitRequest() {
    return this.rmeNodeDaoAbstractService.updateNode(
      this.data.refModel,
      this.data.identity,
      this.editNodeForm.value
    );
  }
}
